module.exports = __webpack_public_path__ + "static/media/greyTag.ee32b583.svg";